import React from 'react';
import EditorXBrandLogo from '@wix/brand-resources/resources/EditorX/EditorX_logo_36x168_white.svg';
import WixBrandLogo from '@wix/brand-resources/resources/WixLogo/WixLogo_17x44_black.svg';
import { LanguagePicker } from './LanguagePicker';
import { useAppContext } from '../../providers/AppContextProvider';
import { Box, TextButton } from '@wix/design-system';

export const Header: React.FC = () => {
  const {
    appContext: { isEditorX, baseurl },
  } = useAppContext();
  return (
    <Box
      align="space-between"
      verticalAlign="middle"
      margin="SP5"
      position="sticky"
      zIndex={1}
    >
      <TextButton as="a" href={baseurl}>
        <span style={{ height: '30px' }}>
          {isEditorX ? (
            <EditorXBrandLogo data-hook="logo" />
          ) : (
            <WixBrandLogo data-hook="logo" />
          )}
        </span>
      </TextButton>
      <LanguagePicker />
    </Box>
  );
};
